import { fetchDataV2 } from "./utils";

export const getVisitToLeadToolToken = () => fetchDataV2("/externalapp/get-external-app-token");
